import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import AdminResaPage from './patron/AdminResaPage';
import { LogOut, CalendarDays, Loader2 } from 'lucide-react';

const EmployeApp = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('lemas_token');
    if (!token) {
      navigate('/login?redirect=/employe');
      return;
    }
    api.get('/auth/me', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        const u = r.data;
        if (!['employe', 'responsable', 'patron'].includes(u.role)) {
          navigate('/');
          return;
        }
        setUser(u);
      })
      .catch(() => {
        localStorage.removeItem('lemas_token');
        localStorage.removeItem('lemas_user');
        navigate('/login?redirect=/employe');
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('lemas_token');
    localStorage.removeItem('lemas_user');
    navigate('/');
  };

  if (loading) return (
    <div className="min-h-screen bg-[rgb(var(--lm-bg))] flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-[rgb(var(--lm-gold))]" />
    </div>
  );

  if (!user) return null;

  return (
    <div className="min-h-screen bg-[rgb(var(--lm-bg))]" data-testid="employe-app">
      {/* Top bar */}
      <div className="border-b border-[rgb(var(--lm-border))] bg-[rgb(var(--lm-surface))]">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <CalendarDays size={16} className="text-[rgb(var(--lm-gold))]" />
            <span className="font-title text-sm tracking-wider text-[rgb(var(--lm-gold))]">LE MAS</span>
            <span className="text-[9px] px-2 py-0.5 rounded-sm bg-[rgb(var(--lm-gold)/0.1)] text-[rgb(var(--lm-gold))] uppercase tracking-wider">
              Reservations
            </span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-[rgb(var(--lm-text-secondary))]">{user.name}</span>
            <span className="text-[9px] px-1.5 py-0.5 rounded-sm bg-[rgb(var(--lm-surface-elevated))] text-[rgb(var(--lm-text-muted))] uppercase tracking-wider">
              {user.role}
            </span>
            <button onClick={handleLogout}
              className="p-1.5 text-[rgb(var(--lm-text-muted))] hover:text-[rgb(var(--lm-red))] transition-colors"
              data-testid="employe-logout">
              <LogOut size={14} />
            </button>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="max-w-6xl mx-auto p-4">
        <AdminResaPage />
      </div>
    </div>
  );
};

export default EmployeApp;
